import { Directive, Input, } from '@angular/core';
import * as i0 from "@angular/core";
export class TextDirective {
    viewContainer;
    templateRef;
    editable = true;
    encode = true;
    field;
    viewRef;
    constructor(viewContainer, templateRef) {
        this.viewContainer = viewContainer;
        this.templateRef = templateRef;
    }
    ngOnChanges(changes) {
        if (changes.field || changes.editable || changes.encode) {
            if (!this.viewRef) {
                this.viewContainer.clear();
                this.viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
            }
            this.updateView();
        }
    }
    updateView() {
        const field = this.field;
        let editable = this.editable;
        if (!field || (!field.editable && (field.value === undefined || field.value === ''))) {
            return;
        }
        // can't use editable value if we want to output unencoded
        if (!this.encode) {
            editable = false;
        }
        const html = field.editable && editable ? field.editable : field.value;
        const setDangerously = (field.editable && editable) || !this.encode;
        this.viewRef.rootNodes.forEach((node) => {
            if (setDangerously) {
                node.innerHTML = html;
            }
            else {
                node.textContent = html;
            }
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TextDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: TextDirective, selector: "[scText]", inputs: { editable: ["scTextEditable", "editable"], encode: ["scTextEncode", "encode"], field: ["scText", "field"] }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: TextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[scText]',
                }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }], propDecorators: { editable: [{
                type: Input,
                args: ['scTextEditable']
            }], encode: [{
                type: Input,
                args: ['scTextEncode']
            }], field: [{
                type: Input,
                args: ['scText']
            }] } });
